<template>
    <QBar
        dense
        class="mp-dock-panel-header bg-grey-2 text-dark"
        @pointerdown="onHeaderPointerDown"
    >
        <QIcon v-if="icon" :name="icon" size="xs" class="q-mr-xs" />
        <span class="col ellipsis">{{ title || panelId }}</span>
        <QSpace />
        <QBtn
            v-if="showPin"
            flat
            dense
            round
            size="sm"
            :icon="pinned ? 'mdi-pin' : 'mdi-pin-off'"
            :aria-label="pinned ? 'Unpin panel' : 'Pin panel'"
            @click.stop="$emit('toggle-pin')"
        >
            <QTooltip>{{ pinned ? 'Unpin' : 'Pin' }}</QTooltip>
        </QBtn>
        <QBtn
            v-if="closable"
            flat
            dense
            round
            size="sm"
            icon="mdi-close"
            aria-label="Hide panel"
            @click.stop="$emit('hide')"
        >
            <QTooltip>Hide panel</QTooltip>
        </QBtn>
    </QBar>
</template>

<script>
import { QBar, QBtn, QIcon, QSpace, QTooltip } from 'quasar';

export default {
    name: 'DockPanelChrome',
    components: { QBar, QBtn, QIcon, QSpace, QTooltip },

    props: {
        panelId: { type: String, default: null },
        title: { type: String, default: '' },
        icon: { type: String, default: null },
        pinned: { type: Boolean, default: true },
        closable: { type: Boolean, default: true },
        showPin: { type: Boolean, default: true },
        mode: {
            type: String,
            default: 'panel',
            validator: (v) => ['panel', 'group'].includes(v),
        },
        groupNodeId: { type: String, default: null },
        groupPanelIds: { type: Array, default: () => [] },
    },

    emits: ['hide', 'toggle-pin', 'drag-start'],

    methods: {
        onHeaderPointerDown(e) {
            if (e.pointerType === 'mouse' && e.button !== 0) return;
            if (e.target.closest('.q-btn')) return;
            e.preventDefault();

            if (this.mode === 'group' && this.groupNodeId) {
                this.$emit('drag-start', {
                    dragMode: 'group',
                    groupNodeId: this.groupNodeId,
                    panelIds: [...this.groupPanelIds],
                    panelId: this.groupPanelIds[0] || this.panelId,
                    title: this.title,
                    clientX: e.clientX,
                    clientY: e.clientY,
                    pointerId: e.pointerId,
                });
                return;
            }

            this.$emit('drag-start', {
                dragMode: 'panel',
                panelId: this.panelId,
                title: this.title,
                clientX: e.clientX,
                clientY: e.clientY,
                pointerId: e.pointerId,
            });
        },
    },
};
</script>
